<template>
  <div
    class="base-card-title__head"
    :class="{ 'base-card-title__head--underline': underline }"
  >
    <h2 class="base-card-title__text" :class="{'base-card-title__text--expanded': expanded}">
      <slot />
    </h2>
    <slot name="right" />
  </div>
</template>

<script>
export default {
  name: 'BaseCardTitle',
  props: {
    underline: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.base-card-title__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &--underline {
    border-bottom: solid 1px rgba(black, 0.2);
    margin-bottom: 20px;

    .base-card-title__text {
      padding-bottom: 0;
      margin-bottom: 10px;

     &--expanded {
        margin-bottom: 22px; // Product catalog has this mb
      }

    }
  }
}
.base-card-title {
  // &__head {

  // }
  &__text {
    font-family: $title-font-family;
    letter-spacing: 0.19px;
    font-size: 1.25rem;
    padding-bottom: 5px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }
}
</style>
